import I18n from 'i18n-js'
global.I18n = I18n

I18n.locale = /^en/.test(document.documentElement.lang) ? 'en' : 'de'

// the translations hash itself is auto-generated.
// to update it with content from the yml files,
// restart the server or run `rake i18n:js:export`
